import * as React from 'react';
import { useSelector } from 'react-redux';
import defaultBackground from './assets/background.png';
import { BackgroundContext, TBackgroundContext } from './context';
import { selectSuburbanRkBackground } from '../../../selectors/countryside';
import { useApplicationContext } from '../../../utils/applicationContext';

export const BackgroundProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const suburbanRkBackground = useSelector(selectSuburbanRkBackground);
  const defaultImageUrl = suburbanRkBackground || defaultBackground;
  const { config } = useApplicationContext();

  const showBackgroundTimeout = config.get<number>('countrysideMainpage.showBackgroundTimeout') || 1500;

  const timer = React.useRef<number | undefined>(undefined);
  const [imageUrl, setImageUrl] = React.useState<string | undefined>(undefined);
  const [isBackgroundShown, setIsBackgroundShown] = React.useState(false);

  React.useEffect(() => {
    timer.current = window.setTimeout(() => {
      setIsBackgroundShown(true);
    }, showBackgroundTimeout);

    return () => {
      window.clearTimeout(timer.current);
    };
  }, []);

  const onAdfoxLoad = React.useCallback((bgImageUrl: string | undefined) => {
    window.clearTimeout(timer.current);
    setImageUrl(bgImageUrl);
    setIsBackgroundShown(true);
  }, []);

  const onAdfoxStub = React.useCallback(() => {
    window.clearTimeout(timer.current);
    setImageUrl(undefined);
    setIsBackgroundShown(true);
  }, []);

  const value = React.useMemo<TBackgroundContext>(
    () => ({
      imageUrl,
      defaultImageUrl,
      isBackgroundShown,
      onAdfoxLoad,
      onAdfoxStub,
    }),
    [imageUrl, defaultImageUrl, isBackgroundShown, onAdfoxLoad, onAdfoxStub],
  );

  return <BackgroundContext.Provider value={value}>{children}</BackgroundContext.Provider>;
};
